export const FICHAS_DIALOG_TITLE = "Gerar Ficha Financeira da Obra";
export const FICHA_VIEWER_TITLE = "Ficha Financeira da Obra";
export const PREVIA_TAG = "Pré-visualização";
/** Toast de erro por 5 s, como na geração da ficha. */
export const PREVIA_BLOQUEADA_LIFE = 5000;
